import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'gatsby';
import BannerAd from './BannerAd';
import { MenuData } from './MenuData';
import SubItems from './SubItems';
import TopItem from './TopItem';


const DesktopNav = () => {
  const [currentDropdown, setCurrentDropdown] = useState('')
  const [collectionDropdown, setCollectionDropdown] = useState(false)
  const [categoryDropdown, setCategoryDropdown] = useState(false)
  const [educationDropdown, setEducationDropdown] = useState(false)
  const [dealsDropdown, setDealsDropdown] = useState(false)
  const [overlay, setOverlay] = useState(false)

  const [desktopDropdown, setDesktopDropdown] = useState(false)
  const [subitemsDropdown, setSubitemsDropdown] = useState(0)

  const triggerDrop = (type, menus, index) => {
    if (type === 'collection') {
      setSubitemsDropdown(0)
      setDesktopDropdown(true)
      setOverlay(true)
      setCurrentDropdown(type)
      setCollectionDropdown(menus)
    }

    if (type === 'education') {
      setSubitemsDropdown(0)
      setDesktopDropdown(true)
      setOverlay(true)
      setCurrentDropdown(type)
      setEducationDropdown(menus)
    }

    if (type === 'deals') {
      // setSubitemsDropdown(0)
      // setDesktopDropdown(true)
      // setOverlay(true)
      // setCurrentDropdown(type)
      // setDealsDropdown(menus)
      setOverlay(false)
      setCurrentDropdown('')
    }

    if (type === 'category') {
      setSubitemsDropdown(0)
      setDesktopDropdown(true)
      setOverlay(true)
      setCurrentDropdown(type)
      setCategoryDropdown(menus)
    }
  }

  /**
   * Hook that alerts hover outside of the passed ref
   */
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if hovered on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOverlay(false)
          setCurrentDropdown('')
        }
      }
      // Bind the event listener
      if (desktopDropdown) {
        document.addEventListener('mouseover', handleClickOutside)
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener('mouseover', handleClickOutside)
        }
      }
    }, [ref, desktopDropdown])
  }

  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)

  return (
    <React.Fragment>
      <div className={`overlay ${overlay ? 'active' : ''}`}></div>
      <div className='d-none d-lg-flex mega-drop-wrapper' ref={wrapperRef}>
        {MenuData.map((top, index) => {
          return (
            <React.Fragment key={top.TopMenuName}>
              {top.type === 'deals' ? (
                <Link
                  to={top.uri}
                  className={`mega-drop ${
                    currentDropdown === top.type ? 'mega-active' : ''
                  }`}
                  onMouseOver={() => triggerDrop(top.type, top.menus, index)}
                >
                  {top.TopMenuName}
                </Link>
              ) : (
                <div
                  className={`mega-drop ${
                    currentDropdown === top.type ? 'mega-active' : ''
                  }`}
                  onMouseOver={() => triggerDrop(top.type, top.menus, index)}
                >
                  {top.TopMenuName}
                </div>
              )}
            </React.Fragment>
          )
        })}

        <nav
          className={
            currentDropdown.length > 0
              ? 'mega-menu-nav active'
              : 'mega-menu-nav'
          }
        >
          <Row className='d-none d-lg-flex'>
            <Col lg={3} className='dropdown-col'>
              {(() => {
                if (currentDropdown === 'collection') {
                  let test = collectionDropdown.map((item, index) => {
                    return (
                      <TopItem
                        key={item.menuName}
                        index={index}
                        name={item.menuName}
                        dropdown={subitemsDropdown}
                        setDropdown={setSubitemsDropdown}
                      />
                    )
                  })
                  return test
                }

                if (currentDropdown === 'education') {
                  let test = educationDropdown.map((item, index) => {
                    return (
                      <TopItem
                        key={item.menuName}
                        index={index}
                        name={item.menuName}
                        dropdown={subitemsDropdown}
                        setDropdown={setSubitemsDropdown}
                      />
                    )
                  })
                  return test
                }

                if (currentDropdown === 'deals') {
                  // let dealsMenus = dealsDropdown.map((item, index) => {
                  //   return (
                  //     <TopItem
                  //       key={item.menuName}
                  //       index={index}
                  //       name={item.menuName}
                  //       dropdown={subitemsDropdown}
                  //       setDropdown={setSubitemsDropdown}
                  //       type={currentDropdown}
                  //       uri={item.uri}
                  //     />
                  //   )
                  // })
                  // return dealsMenus
                }

                if (currentDropdown === 'category') {
                  let dealsMenus = categoryDropdown.map((item, index) => {
                    return (
                      <TopItem
                        key={item.menuName}
                        index={index}
                        name={item.menuName}
                        dropdown={subitemsDropdown}
                        setDropdown={setSubitemsDropdown}
                        type={currentDropdown}
                        uri={item.uri}
                      />
                    )
                  })
                  return dealsMenus
                }
              })()}
            </Col>
            <Col
              lg={3}
              className={
                currentDropdown === 'deals' || currentDropdown === 'category'
                  ? 'd-none'
                  : ''
              }
            >
              {(() => {
                if (currentDropdown === 'collection') {
                  let categorySubitems = typeof subitemsDropdown == 'number' &&
                    collectionDropdown[subitemsDropdown] &&
                    collectionDropdown[subitemsDropdown].subitems && (
                      <SubItems
                        subitems={collectionDropdown[subitemsDropdown].subitems}
                      />
                    )

                  return categorySubitems
                }

                if (currentDropdown === 'education') {
                  let educationSubitems = typeof subitemsDropdown == 'number' &&
                    educationDropdown[subitemsDropdown] &&
                    educationDropdown[subitemsDropdown].subitems && (
                      <SubItems
                        subitems={educationDropdown[subitemsDropdown].subitems}
                      />
                    )

                  return educationSubitems
                }

                if (currentDropdown === 'deals') {
                  let dealsSubitems = typeof subitemsDropdown == 'number' &&
                    dealsDropdown[subitemsDropdown] &&
                    dealsDropdown[subitemsDropdown].subitems && (
                      <SubItems
                        subitems={dealsDropdown[subitemsDropdown].subitems}
                      />
                    )

                  return dealsSubitems
                }

                if (currentDropdown === 'category') {
                  let categorySubitems = typeof subitemsDropdown == 'number' &&
                    categoryDropdown[subitemsDropdown] &&
                    categoryDropdown[subitemsDropdown].subitems && (
                      <SubItems
                        subitems={categoryDropdown[subitemsDropdown].subitems}
                      />
                    )

                  return categorySubitems
                }
              })()}
            </Col>

            {(() => {
              if (currentDropdown === 'collection') {
                return (
                  <BannerAd
                    banner={MenuData[0].bannerAd}
                    currentDropdown={currentDropdown}
                  />
                )
              }
              if (currentDropdown === 'education') {
                return (
                  <BannerAd
                    banner={MenuData[2].bannerAd}
                    currentDropdown={currentDropdown}
                  />
                )
              }

              if (currentDropdown === 'deals') {
                return (
                  <BannerAd
                    banner={MenuData[3].bannerAd}
                    currentDropdown={currentDropdown}
                  />
                )
              }
              if (currentDropdown === 'category') {
                return (
                  <BannerAd
                    banner={MenuData[1].bannerAd}
                    currentDropdown={currentDropdown}
                  />
                )
              }
            })()}
          </Row>
        </nav>
      </div>
    </React.Fragment>
  )
}

export default DesktopNav